import './TermsAndConditions.css';

export function TermsAndConditions() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <div className="terms-header">
          <h1 className="terms-title">Terms and Conditions</h1>
          <p className="last-updated">Last Updated: March 1, 2026</p>
        </div>

        <div className="terms-intro">
          <p>
            Welcome to Golden777. These Terms and Conditions outline the rules and regulations for the use of the
            Golden777 App and the website located at golden777.fun.
          </p>
        </div>

        <section className="terms-section">
          <h2 className="terms-heading">1. Acceptance of Terms</h2>
          <p>
            By accessing this website or downloading the Golden777 app, we assume you accept these terms and
            conditions. Do not continue to use Golden777 if you do not agree to take all of the terms and
            conditions stated on this page.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">2. Eligibility</h2>

          <h3 className="terms-subheading">Age Requirement</h3>
          <p>
            You must be at least 18 years of age (or the legal age of majority in your jurisdiction) to use this
            service.
          </p>

          <h3 className="terms-subheading">Jurisdiction</h3>
          <p>
            Users are responsible for ensuring that online gaming is legal in their territory. Golden777 is void
            where prohibited by law.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">3. User Accounts</h2>
          <ul className="terms-list">
            <li>You are responsible for maintaining the confidentiality of your account and password.</li>
            <li>You agree to provide accurate and current information during the registration process.</li>
            <li>
              Golden777 reserves the right to terminate accounts that are found to be fraudulent or in violation
              of these terms.
            </li>
          </ul>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">4. In-Game Currency and Purchases</h2>

          <h3 className="terms-subheading">Virtual Items</h3>
          <p>
            Golden777 may include virtual currency (coins, credits, or gems) that can be purchased with real
            money.
          </p>

          <h3 className="terms-subheading">No Real-World Value</h3>
          <p>
            Virtual items have no equivalent "real world" value and cannot be redeemed for legal tender or items
            of value outside the game.
          </p>

          <h3 className="terms-subheading">Refunds</h3>
          <p>All purchases are final and non-refundable unless otherwise required by law.</p>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">5. Prohibited Conduct</h2>
          <p>You agree not to:</p>
          <ul className="terms-list">
            <li>Use cheats, automation software (bots), or hacks to modify the game experience.</li>
            <li>Attempt to reverse-engineer or extract the source code of the app.</li>
            <li>Harass other players or use offensive language in community areas.</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2 className="terms-heading">6. Limitation of Liability</h2>
          <p>
            Golden777 and its affiliates shall not be liable for any indirect, incidental, or consequential
            damages resulting from your use or inability to use the service. The game is provided on an "as-is"
            and "as-available" basis.
          </p>
        </section>
      </div>
    </div>
  );
}
